import { render, staticRenderFns } from "./LogoutIcon.vue?vue&type=template&id=6c8c67e9&scoped=true&"
import script from "./LogoutIcon.vue?vue&type=script&lang=js&"
export * from "./LogoutIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c67e9",
  null
  
)

export default component.exports